import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ResetPassword } from '../../../shared/models/rest-password.model';
import { PasswordRecoveryRepository } from '../repositories/password-recovery.repository';

@Injectable()
export class PasswordRecoveryService {
  // expose repository methods directly to avoid duplicated boilerplate
  recoverPassword: (username: string) => Observable<any>;
  resetPassword: (username: string, resetToken: string, passwords: ResetPassword) => Observable<any>;
  checkResetTokenValid: (username: string, token: string) => Observable<any>;

  constructor(private passwordRepository: PasswordRecoveryRepository) {
    this.recoverPassword = this.passwordRepository.recoverPassword.bind(this.passwordRepository);
    this.resetPassword = this.passwordRepository.resetPassword.bind(this.passwordRepository);
    this.checkResetTokenValid = this.passwordRepository.checkResetTokenValid.bind(this.passwordRepository);
  }
}
